import { AtomField } from 'atoms/form-atoms';
import { Dropdown, DropdownProps, Layer } from '@carbon/react';
import { useAtomValue, useSetAtom } from 'jotai';
import { ReactNode } from 'react';
import style from './dropdown-field.module.scss';
import classNames from 'classnames';

interface SelectableFieldProps<Items extends string | null> extends Omit<
  DropdownProps<Items>,
  'light' | 'titleText'
> {
  field: AtomField<Items>;
  titleText?: ReactNode;
  required?: boolean;
  light?: boolean;
}
const DropdownField = <Items extends string | null>({
  field,
  onChange,
  titleText,
  required,
  light,
  ...rest
}: SelectableFieldProps<Items>) => {
  const setValue = useSetAtom(field);
  const fieldObj = useAtomValue(field);

  const dropdown = (
    <Dropdown<Items>
      titleText={
        <label>
          {titleText}
          {required ? <span>(Required)</span> : ''}
        </label>
      }
      selectedItem={fieldObj.value}
      onChange={(event) => {
        if (
          typeof event.selectedItem !== 'undefined' &&
          event.selectedItem !== null
        ) {
          setValue(event.selectedItem);
          onChange?.(event);
        }
      }}
      itemToString={(item) => item ?? ''}
      invalid={!fieldObj.isValid && fieldObj.isDirty}
      invalidText={!fieldObj.isValid && fieldObj.isDirty ? fieldObj.error : ''}
      {...rest}
    />
  );

  return (
    <div className={classNames({ [style.light]: light })}>
      {light ? <Layer>{dropdown}</Layer> : dropdown}
    </div>
  );
};

export { DropdownField };
